// IndustryComponent.js
import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";

function IndustryComponent() {
  const [industry, setIndustry] = useState([]);

  // Sample data for Industry
  const IndustryList = [
    { value: "Information Technology", label: "Information Technology" },
    { value: "Automotive", label: "Automotive" },
    {
      value: "Healthcare & Pharmaceuticals",
      label: "Healthcare & Pharmaceuticals",
    },
    { value: "Finance & Banking", label: "Finance & Banking" },
    { value: "Retail & E-commerce", label: "Retail & E-commerce" },
    { value: "Education & E-learning", label: "Education & E-learning" },
    { value: "Telecommunications", label: "Telecommunications" },
    { value: "Real Estate", label: "Real Estate" },
    { value: "Manufacturing", label: "Manufacturing" },
    { value: "Aerospace & Defense", label: "Aerospace & Defense" },
    {
      value: "Construction & Engineering",
      label: "Construction & Engineering",
    },
    {
      value: "Transportation & Logistics",
      label: "Transportation & Logistics",
    },
    { value: "Energy & Utilities", label: "Energy & Utilities" },
    { value: "Media & Entertainment", label: "Media & Entertainment" },
    {
      value: "Agriculture & Food Processing",
      label: "Agriculture & Food Processing",
    },
    { value: "Hospitality & Tourism", label: "Hospitality & Tourism" },
    {
      value: "Government & Public Sector",
      label: "Government & Public Sector",
    },
    { value: "Non-profit & NGOs", label: "Non-profit & NGOs" },
    { value: "Legal Services", label: "Legal Services" },
    { value: "Chemical & Petrochemical", label: "Chemical & Petrochemical" },
    { value: "Mining & Metals", label: "Mining & Metals" },
    { value: "Insurance", label: "Insurance" },
    { value: "Consumer Goods", label: "Consumer Goods" },
    { value: "Biotechnology", label: "Biotechnology" },
    { value: "Fashion & Apparel", label: "Fashion & Apparel" },
    { value: "Environmental Services", label: "Environmental Services" },
    { value: "Food & Beverage", label: "Food & Beverage" },
    { value: "Renewable Energy", label: "Renewable Energy" },
    { value: "Cybersecurity", label: "Cybersecurity" },

    { value: "PetroChemical", label: "Petrochemical" },
  ];
  // Function to handle selection change
  const handleIndustryChange = (selectedOptions) => {
    setIndustry(selectedOptions || []);
  };

  return (
    <div className="mb-4">
      <label className="block text-gray-700 font-bold mb-2">Industry</label>
      <CreatableSelect
        isMulti
        options={IndustryList}
        value={industry}
        onChange={handleIndustryChange}
        placeholder="Select Industry"
        className="mb-4"
      />
    </div>
  );
}

export default IndustryComponent;
